import {useEffect} from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import Logger from '@nl/logger';
import {event, EVENT_TYPES} from '../utils/event';

function useNLAAUITracker() {
	const {initialized} = useSelector((state) => state.client, shallowEqual);

	// Initialization
	useEffect(() => {
		const addRemoveFavPlayerCallback = (isAdd, playerInfo, allFavPlayers = []) => {
			if (window.g_NLAAUI) {
				try {
					const myFavePlayers = allFavPlayers.map(({id: idInfo}) => {
						const [id, f, l] = idInfo.split(':');
						return {id, f, l};
					});
					window.g_NLAAUI.getNBAClient().updateFavoritePlayers(myFavePlayers);
				} catch (e) {
					Logger.error('useNLAAUITracker: g_NLAAUI.getNBAClient().updateFavoritePlayers error!', e);
				}
			} else {
				Logger.error('useNLAAUITracker: window.g_NLAAUI doesn\'t exist');
			}
		};
		const addRemoveFavTeamCallback = (isAdd, teamInfo, allFavTeams = []) => {
			if (window.g_NLAAUI) {
				try {
					const myFaveTeams = Object.values(allFavTeams).map(({id, code}) => ({id, code}));
					window.g_NLAAUI.getNBAClient().updateFavoriteTeams(myFaveTeams);
				} catch (e) {
					Logger.error('useNLAAUITracker: g_NLAAUI.getNBAClient().updateFavoriteTeams error! ', e);
				}
			} else {
				Logger.error('useNLAAUITracker: window.g_NLAAUI doesn\'t exist');
			}
		};
		if (initialized) {
			event.on(EVENT_TYPES.TRACK_FAVORITE_PLAYER_ADDED, addRemoveFavPlayerCallback)
					.on(EVENT_TYPES.TRACK_FAVORITE_PLAYER_REMOVED, addRemoveFavPlayerCallback)
					.on(EVENT_TYPES.TRACK_FAVORITE_TEAM_ADDED, addRemoveFavTeamCallback)
					.on(EVENT_TYPES.TRACK_FAVORITE_TEAM_REMOVED, addRemoveFavTeamCallback);
		}
		return () => {
			if (initialized) {
				event.off(EVENT_TYPES.TRACK_FAVORITE_PLAYER_ADDED, addRemoveFavPlayerCallback)
						.off(EVENT_TYPES.TRACK_FAVORITE_PLAYER_REMOVED, addRemoveFavPlayerCallback)
						.off(EVENT_TYPES.TRACK_FAVORITE_TEAM_ADDED, addRemoveFavTeamCallback)
						.off(EVENT_TYPES.TRACK_FAVORITE_TEAM_REMOVED, addRemoveFavTeamCallback);
			}
		};
	}, [initialized]);
}

export default useNLAAUITracker;
